<template>
<v-form v-model="valid" ref="form">
    <v-row class="ma-0 pa-0" v-show="readonly">
        <v-col cols="auto" class="d-flex justify-start ps-0 pt-0">
        <bee-btn context="material" :action-name="actions.EDIT"  color="editingColor" @click="$router.push({name: 'update-material', params: {id: material.id}})" :loading="loading" :disabled="file_is_locked" outer-class="me-3">
            <template v-slot:content="" >
                <v-img width="25" contain :src="require('../../../../assets/edit-product.png')" class="mx-1"></v-img>
                {{$t('MaterialCreateEdit.edit')}}
            </template>
        </bee-btn>
        <bee-btn context="material" :action-name="actions.DELETE" color="deletingColor" :loading="loading" @click="deleteDialog = true" :disabled="file_is_locked">
            <template v-slot:content="" >
                <v-img width="25" contain :src="require('../../../../assets/remove-product.png')" class="mx-1"></v-img>
                {{$t('MaterialCreateEdit.delete')}}
            </template>
        </bee-btn>
        </v-col>
    </v-row>
    <v-row class="ma-0 pa-0" v-show="!readonly">
        <v-col cols="auto" class="d-flex justify-start ps-0 pt-0">
        <bee-btn context="material" :action-name="actions.EDIT"  color="editingColor" @click="save()" :loading="loading" :disabled="(materialItems.length === 0 && !valid) || file_is_locked" outer-class="me-3">
            <template v-slot:content="" >
                <v-img width="25" contain :src="require('../../../../assets/save-product.png')" class="mx-1"></v-img>
                {{$t('MaterialCreateEdit.save')}}
            </template>
        </bee-btn>
        <bee-btn
            context="material"
            :action-name="actions.DELETE"
            color="deletingColor"
            :content="$t('MaterialCreateEdit.cancel')"
            :loading="loading"
            @click="cancel()"
        >
        </bee-btn>
        </v-col>

		<v-spacer></v-spacer>
		<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="pt-0">
			<v-autocomplete
				v-if="copyToOtherWarehouses && $route.name === 'update-material' && multipleWarehouses"
				:items="allMaterialEditTypes"
				v-model="materialEditType"
				:disabled="readonly"
				item-text="name"
				item-value="id"
				:label="$t('MaterialCreateEdit.edit-material-between-warehouses')"
				dense
				outlined
				hide-details
				class="rounded-lg"
			></v-autocomplete>
		</v-col>
    </v-row>
	<v-card>
        <v-card-text class="pt-0">
                <v-card-title class="px-0">
					{{$t('MaterialCreateEdit.basic-data')}}
				</v-card-title>
                <v-layout align-start align-content-center justify-space-between row wrap>
					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.material-name')"
						    :rules="[rules.required]"
						    v-model="material.name"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<!-- working here -->
						<bee-material-autocomplete
						    :with-balance="true"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.main-material')"
						    color="primary"
						    @change="change()"
						    v-model="material.parent_id"
						    :items="warehouse_materials.filter(c=>c.type == 1)"
						    :clearable="true"
						></bee-material-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<!-- working here -->
						<bee-accounting-no-field
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.material-no-is-automatic-or-manual')"
						    ref="innerNo"
						    :prefix="prefix"
						    v-model="material.inner_no"
						    :rules="[rules.required]"
						></bee-accounting-no-field>
					</v-col>
					
					<!-- barcode -->
					<v-col v-if="multipleWarehouses" cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<!-- 245800224057 -->
						<v-text-field 
							v-model="material.barcode"
							outlined
							dense
							hide-details
							type="number"
							hide-spin-buttons
							:label="$t('inputs.barcode')"
							:disabled="readonly"
						/>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    color="primary"
						    :label="$t('MaterialCreateEdit.material-type.title')"
						    item-text="name"
						    item-value="value"
						    :items="configs.material_types.filter(c=>c.value).map(c=>({...c,
								name:
								c.value == 1 ? $t('MaterialCreateEdit.material-type.main') :
								c.value == 2 ? $t('MaterialCreateEdit.material-type.sub') :
								c.name })) || []"
						    v-model="material.type"
						    :rules="[rules.required]"
						></bee-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.material-category.title')"
						    item-value="value"
						    itemText="name"
						    :items="configs.material_categories.filter(c=>c.value).map(c=>({...c,
							name:
								c.value == materialCategory.commodity ? $t('MaterialCreateEdit.material-category.commercial-ordinary-material') :
								c.value == materialCategory.raw ? $t('MaterialCreateEdit.material-category.raw-material') :
								c.value == materialCategory.indirectRaw ? $t('MaterialCreateEdit.material-category.indirect-raw-material') :
								c.value == materialCategory.inProcess ? $t('MaterialCreateEdit.material-category.material-under-manufacture') :
								c.value == materialCategory.finished ? $t('MaterialCreateEdit.material-category.manufactured-material') :
								c.name })) || []"
						    v-model="material.category"
						    :rules="[rules.required]"
						></bee-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-autocomplete
						    context="unit_size"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.unit-size')"
						    item-value="id"
						    itemText="name"
						    :items="unit_sizes"
						    v-model="material.unit_size_id"
						    :rules="[rules.required]"
						></bee-autocomplete>
					</v-col>

					<v-col v-if="useAdvancedMaterialDetails" cols="12" lg="4" sm="6" class="py-1">
						<v-text-field
							v-model="material.english_name"
							dense
							outlined
							:disabled="readonly"
							:label="$t('MaterialCreateEdit.english-name')"
						></v-text-field>
					</v-col>

					<v-col v-if="useAdvancedMaterialDetails" cols="12" lg="4" sm="6" class="py-1">
						<v-text-field
							v-model="material.manufacturer_code"
							dense
							outlined
							:disabled="readonly"
							:label="$t('MaterialCreateEdit.manufacturer-code')"
						></v-text-field>
					</v-col>
					
				</v-layout>

				<v-card-title class="pt-0 px-0">
					{{$t('MaterialCreateEdit.additional-data')}}
				</v-card-title>
                <v-layout align-start align-content-center row wrap>
					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.min')"
						    :rules="[rules.numeric]"
						    v-model.number="material.min_quantity"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.max')"
						    :rules="[rules.numeric]"
						    v-model.number="material.max_quantity"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.manufacturer')"
						    v-model="material.manufacturer"
						></bee-text-field>
					</v-col>

					<v-col cols="12" lg="12" md="12" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.specifications')"
						    v-model="material.specifications"
						></bee-text-field>
					</v-col>

					<v-col v-if="useAdvancedMaterialDetails" cols="12" lg="4" sm="6" class="py-1">
						<v-text-field
							v-model="material.country_of_origin"
							dense
							outlined
							:disabled="readonly"
							:label="$t('MaterialCreateEdit.country-of-origin')"
						></v-text-field>
					</v-col>
					<v-col class="d-flex align-center">
						<v-checkbox
							v-model="material.is_required_serial_num"
							dense
							:label="$t('MaterialCreateEdit.has-serial-number')"
							:disabled="readonly"
						>
						</v-checkbox>
					</v-col>
                </v-layout>

				<v-card-title class="pt-0 px-0">
					{{$t('MaterialCreateEdit.material-movement-data')}}
				</v-card-title>
                <v-layout align-start align-content-center justify-space-between row wrap>
					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-money-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.purchasing-price')"
						    v-model="material.purchase_price"
						    :rules="[rules.money]"
						></bee-money-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-money-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.selling-price')"
						    v-model="material.sale_price"
						    :rules="[rules.money]"
						></bee-money-field>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.purchase-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.purchases_account_id "
						    :items="configs.accounts.filter(c=>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('inputs.purchasing-refund-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.purchases_refund_account_id "
						    :items="configs.accounts.filter(c =>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.sales-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.sales_account_id "
						    :items="configs.accounts.filter(c=>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>

					<v-col cols="12" lg="4" md="4" sm="6" xs="12" class="py-1">
						<bee-account-autocomplete
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('inputs.sales-refund-account')"
						    color="primary"
						    :clearable="true"
						    :with-balance="true"
						    v-model="material.sales_refund_account_id "
						    :items="configs.accounts.filter(c =>c.final_type == 2)"
						></bee-account-autocomplete>
					</v-col>
					
					<v-col cols="12" lg="8" md="8" sm="6" xs="12" class="py-1">
						<bee-text-field
						    context="material"
						    :action-name="actions.CREATE"
						    :disabled="readonly"
						    :label="$t('MaterialCreateEdit.notes')"
						    v-model="material.notes"
						></bee-text-field>
					</v-col>
                </v-layout>

				<!-- edit between warehouses table: -->
				<p v-if="materialEditType === 0 && $route.path.includes('/update-material') && copyToOtherWarehouses === true" class="my-3 text-h6">
					{{ $t('MaterialCreateEdit.linked-material-in-other-warehouses') }}
				</p>

				<div v-if="materialEditType === 0 && $route.path.includes('/update-material') && copyToOtherWarehouses === true" class="my-4">
					<bee-handy-table
						:headers="editStatusHeaders"
						:items="editStatusItems"
						dense 
						zebra
						fixed-header
						hide-default-footer
						:loading="editTableLoading"
						mobile-breakboint="960"
					>
						<template v-slot:item.materials="{ index }">
							<v-autocomplete
								v-model="editStatusItems[index].parent_id"
								:items="
									materials.filter(c =>
										c.type === type.main &&
										itemLinkedWithMaterials.some(f => f.warehouse_id === c.warehouse_id) &&
										c.warehouse_id === editStatusItems[index].warehouse_id
									)
								"
								item-text="name"
								item-value="id"
								hide-details
								class="mb-3"
								@change="suggestMaterialEditNo(index)"
							></v-autocomplete>
						</template>

						<template v-slot:item.number="{ index }">
							<v-text-field
								v-model="editStatusItems[index].inner_no"
								:disabled="readonly"
								:prefix="getMaterialById(editStatusItems[index].parent_id)?.no"
								style="direction: ltr !important;"
								class="custom custom-prefix"
								>
							</v-text-field>
						</template>
					</bee-handy-table>
				</div>

				<v-checkbox
					v-if="$route.path.includes('/create-material') && useCopyMaterial"
					v-model="addToAllWarehouses"
					:label="$t('MaterialCreateEdit.add-to-all-warehouses-check')"
					@change="warehousesInputs = {}"
				></v-checkbox>
				<v-checkbox
					v-if="copyToOtherWarehouses === true && !$route.path.includes('/create-material') && useCopyMaterial"
					v-model="addToAllWarehouses"
					:label="$t('MaterialCreateEdit.copy-to-other-warehouses-check')"
					@change="warehousesInputs = {}"
				></v-checkbox>


				<!-- the add and edit table -->

				<div v-if="addToAllWarehouses" class="mt-2 mb-4">
					<bee-handy-smart-table
						ref="duplicationMaterialTable"
						v-model="warehousesInputs"
						fixed-header
						:headers="materialHeaders"
						:items="materialItems"
						dense
						hide-inputs-details
						hide-default-footer
						editable-rows
						show-add-row
						@keypress.enter="
							editIndex === null
								? addMaterialToWarehouses()
								: (() => {
									if (!$refs.duplicationMaterialTable.validate()) return;
									materialItems[editIndex].name = warehousesInputs.warehouse;
									materialItems[editIndex].materials = warehousesInputs.material;
									materialItems[editIndex].financial_file_id = warehousesInputs.number;
									$refs.duplicationMaterialTable.resetEdit();			
								})()
						"
						@edit-cancelled="editIndex = null"
					>
						<template v-slot:input.warehouse="{attr, on}">
							
							<v-autocomplete
								:items=" 
									$route.path.includes('/create-material')
										?
										warehouses.filter(c =>
											c.id !== +$route.params.warehouseId && (
												!materialItems.map(c => c.name).includes(c.id) ||
												(editIndex !== null ? c.id === materialItems[editIndex].name : false)
												)
											)
										
										:
										warehouses.filter(c =>
											!itemLinkedWithMaterials.some(item => item.warehouse_id === c.id) &&
											c.id !== +$route.params.warehouseId && (
												!materialItems.map(c => c.name).includes(c.id) ||
												(editIndex !== null ? c.id === materialItems[editIndex].name : false)
												)
											)
										"
								item-text="name"
								item-value="id"
								v-bind="attr" 
								v-on="on"
								@change="warehousesInputs.material = null;"
							></v-autocomplete>
						</template>

						<template v-slot:input.material="{attr, on}">
							<v-autocomplete
								:items="materials.filter(c => c.type === type.main && c.warehouse_id === warehousesInputs.warehouse)"
								item-text="name"
								item-value="id"
								v-bind="attr" 
								v-on="on"
								@change="suggestMaterialNo()"
							></v-autocomplete>
						</template>

						<template v-slot:input.number="{attr, on}">
							<v-text-field
								:disabled="readonly"
								v-bind="{...attr}" 
								v-on="{...on}"
								:prefix="materialNumberPrefix"
								style="direction: ltr !important;"
								class="custom custom-prefix"
							></v-text-field>
						</template>

						<template v-slot:item.actions="{ item, index }">
							<div class="d-flex">
								<v-btn
									depressed
									rounded
									icon
									color="warning"
									@click="$refs.duplicationMaterialTable.activeEditForRow(index); editIndex = index"
								>
									<v-icon size="22">mdi-pencil</v-icon>
								</v-btn>
								<v-btn
									depressed
									rounded
									icon
									color="red"
									@click="materialItems.splice(index, 1)"
								>
									<v-icon size="22">mdi-delete</v-icon>
								</v-btn>
							</div>
						</template>

					</bee-handy-smart-table>
				</div>

			</v-card-text>
    </v-card>
	<!-- materials linked -->
	<!-- dialog -->
	<template v-if="multipleWarehouses">
		<v-dialog
			v-model="unbindDialog"
			persistent
			max-width="400px"
			transition="dialog-top-transition"
		>
			<v-card>
				<v-card-title> {{ $t('MaterialCreateEdit.confirm-disengagement-of-material') }} </v-card-title>
				<v-card-text>
					{{$t('MaterialCreateEdit.are-you-sure-you-want-to-disconnect?')}}
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="deleteLinkItem()" :loading="loading" color="deletingColor" text>
						{{ $t('buttons.ok') }}
					</v-btn>
					<v-btn text @click="unbindDialog = false">
						{{ $t('cancel') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-card 
			v-if="(Boolean($route.params.id) && (userTypePermission === userType.warehouseManger)) || 
			(Boolean($route.params.id) && isAdmin)" class="mt-2"
		>
			<!-- <v-card-title>
				{{ $t('MaterialCreateEdit.interlocking-materials') }}
			</v-card-title> -->
			<v-card-text class="pt-0">
				<!--  -->
				<h3 class="pb-2">
					{{ $t('MaterialCreateEdit.materials-that-have-the-same-barcode') + ':'}}
				</h3>
	
				<!-- materialSameBarcode -->
				<bee-handy-table
					:items="materialSameBarcode.filter(c => c.id !== material.id)"
					:headers="headerSameBar"
					zebra
					dense
					:items-per-page="-1"
					hide-default-footer
					class="mb-3"
					height="auto"
					:loading="loading"
				>
					<template v-slot:item.actions="{ item }">
						<v-btn @click="link(item.id)" icon color="success" :disabled="readonly">
							<v-icon> mdi-link-box-variant-outline </v-icon>
						</v-btn>
					</template>
				</bee-handy-table>
				<bee-handy-smart-table
					ref="table"
					v-model="tableInputs"
					:items="itemLinkedWithMaterials"
					:headers="headers"
					dense
					zebra
					:items-per-page="-1"
					:show-add-row="!loading && !readonly"
					hide-default-footer
					@keypress.enter="link()"
					:loading="loading"
				>
					<template v-slot:input.warehouse_id="{ on, attrs }">
						<v-autocomplete 
							:items="warehouses.filter(c => c.id !== $route.params.warehouseId)"
							item-text="name"
							item-value="id"
							v-on="on"
							v-bind="attrs"
						/>
					</template>
	
					<template v-slot:input.id="{ on, attrs }">
						<v-autocomplete 
							:items="materials.filter(c => c.warehouse_id === tableInputs.warehouse_id)"
							item-text="name"
							item-value="id"
							v-on="on"
							v-bind="attrs"
						/>
					</template>
					<template v-slot:item.actions="{ item }">
						<div class="d-flex justify-end">
							<v-btn icon @click="itemId = item.id; unbindDialog = true" :disabled="readonly">
								<v-icon color="danger-dark-color">mdi-delete</v-icon>
							</v-btn>
						</div>
					</template>
				</bee-handy-smart-table>
			</v-card-text>
		</v-card>
	</template>
	
					
			
		<!-- materials linked -->
		<!-- dialog -->
		<v-dialog
			v-model="unbindDialog"
			persistent
			max-width="400px"
			transition="dialog-top-transition"
		>
			<v-card>
				<v-card-title> {{ $t('MaterialCreateEdit.confirm-disengagement-of-material') }} </v-card-title>
				<v-card-text>
					{{$t('MaterialCreateEdit.are-you-sure-you-want-to-disconnect?')}}
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn @click="deleteLinkItem()" :loading="loading" color="deletingColor" text>
						{{ $t('buttons.ok') }}
					</v-btn>
					<v-btn text @click="unbindDialog = false">
						{{ $t('cancel') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>		
		
		<v-card v-if="useInvoicesTypes" class="mt-4">
			<v-card-title></v-card-title>
			<v-card-text></v-card-text>
		</v-card>
	
		<!-- material linked -->
		<v-card></v-card>
	
		<bee-dialog
			@handler="confirmDelete()"
			@close="deleteDialog = false"
			v-model="deleteDialog"
			:title="$t('MaterialCreateEdit.delete-the-material')"
			:message="$t('MaterialCreateEdit.are-you-sure-you-want-to-delete-the-material-$', {materialName: material.name})"
		></bee-dialog>
	</v-form>
</template>

<script>
import rules from "@/validation";
import { mapGetters, mapState } from "vuex";
import  store  from "@/store/index.js";
// import EventBus from '@/event-bus'
import actions from "@/permissions/actions-names.js"
import { multipleWarehouses, useInvoicesTypes, isMangeUnitAndRegionAndPatchAndLot, useAdvancedMaterialDetails, useCopyMaterial } from '@/configs/global';
import { materialCategory, userType, type, materialEditTypes } from '@/helpers/enums'
import validation from '@/validation';
export default {
   data: () => ({
	// configs
	useInvoicesTypes,
	materialCategory,
	multipleWarehouses,
	useAdvancedMaterialDetails,
	rules: validation.rules,
	useCopyMaterial,
	deleteDialog: false,
    readonly: true,
	actions,
    valid:false,
    material: {
		name: null,
		inner_no: null,
		type: null,
		category: null,
		purchase_price: null,
		sale_price: null,
		notes: null,
		parent_id: null,
		id: null,
		purchases_account_id: null,
		purchases_refund_account_id: null,
		sales_account_id: null,
		sales_refund_account_id: null,
		manufacturer: null,
		min_quantity: null,
		max_quantity: null,
		specifications: null,
		unit_size_id: null,
		barcode: null,
		english_name: null,
		manufacturer_code: null,
		country_of_origin: null,
		is_required_serial_num: false,
    },
	...rules,
	loading : false,
	// selectedId : null,
	
	default_material:{
		name: null,
		inner_no: null,
		type: null,
		category: null,
		purchase_price: {
			amount: null,
			currency_id: null
		},
		sale_price: {
			amount: null,
			currency_id: null
		},
		notes: null,
		parent_id: null,
		id: null,
		purchases_account_id: null,
		sales_account_id: null,
		manufacturer: null,
		min_quantity: null,
		max_quantity: null,
		specifications: null,
		unit_size_id: null,
		barcode: null,
		english_name: null,
		manufacturer_code: null,
		country_of_origin: null
	},
    editable: true,
	tableInputs: {},
	itemLinkedWithMaterials: [],
	editStatusItems: [],
	materialSameBarcode: [],
	unbindDialog: false,
	itemId: null,
	userType,
	type,
	entriesUnitsLinked: [],
	tableInputsUnitLinked: {},
	itemsRegion: [],
	regions: [
		{
			name: 'A',
			class: 'A',
			column: '1',
			notes: 'لايوجد',
			id: 5
		},
		{
			name: 'B',
			class: 'S',
			column: '2',
			id: 1
		},
		{
			name: 'C',
			class: '12',
			column: 'w',
			id: 2
		}
	],
	tableInputRegion: {},
	rowEditIndexRegion: null,
	regionId: null,
	resetEditRegion: false,
	isEditRegion: false,
	tab: 0,
	resetEditUnit: false,
	isEditUnit: false,
	rowEditIndexUnit: null,
	unitId: null,
	isMangeUnitAndRegionAndPatchAndLot,

	addToAllWarehouses: false,

	warehousesInputs: {},

	materialItems: [],

	editIndex: null,

	copyToOtherWarehouses: false,
	materialEditTypes,

	materialEditType: null,

	editMainMaterial: null,

	editTableLoading: false

  }),  
  mounted(){
	this.loading = false
	// this.selectedId = Number(this.$route.params.id)
	if(this.$route.name === 'show-material') {
		this.readonly = true;
	} else {
		this.readonly = false;
	}
	if(this.$route.name == "update-material") {
		this.copyToOtherWarehouses = true;
	} 
    if(this.$route.name == "create-material")
		this.reSet() 
	if(this.$route.name == "add-material")
	{
		this.reSet() 
		this.initializeParent() 
	}
	if(
		(this.userTypePermission === userType.warehouseManger && this.$route.name !== 'create-material') 
		|| (this.isAdmin && this.$route.name !== 'create-material')
	) {
		this.getMaterialLinked()
	}
	// if(this.$route.name != "create-material") {
	if(!this.warehouses.length) {
		this.$store.dispatch('warehouses/fetchAll')
	}
	if(!this.materials.length) {
		this.$store.dispatch('materials/fetchAll')
	}
	// }
  },
  computed: {
	...mapState("configs", ["configs"]),
	...mapState("unitSizes", ["unit_sizes"]),
	// ...mapState("materials", ["warehouse_materials"]),
	...mapState("materials", ["materials_tree"]),
	...mapState({
		materials: state => state.materials.materials,
		warehouses: state => state.warehouses.warehouses,
		userTypePermission: state => state.permissions.user_type,
		isAdmin: state => state.auth.self.is_admin
	}),
	...mapGetters({
		getWarehousesById: 'warehouses/getById',
		getMaterialById: 'materials/getMaterialById',
		getSettingByKey: 'settings/getSettingByKey'
	}),
	formTitle(){
		return this.this.$route.name == 'update-material'
			? this.$t('MaterialCreateEdit.edit-material')
			: this.$t('MaterialCreateEdit.create-material');
	},
	prefix(){
		if(this.material.parent_id)
			return this.warehouse_materials.find(c=>c.id == this.material.parent_id)?.no.toString()
		return null },
	materialNumberPrefix() {
		if(this.warehousesInputs.material)
			return this.materials.find(c => c.id == this.warehousesInputs.material).no;
		return null
	},
	editMaterialNumberPrefix() {
		return this.editStatusItems.find(c => c.parent_id).no ? this.editStatusItems.find(c => c.parent_id) : null
	},
	file_is_locked(){
        return this.configs?.financial_file?.is_locked 
    },
	headers() {
		const headers = [
			{
				text: this.$t('inputs.warehouse'),
				name: 'warehouse_id',
				value: 'warehouse_id',
				setValueExpr: val => this.getWarehousesById(val)?.name
			},
			{
				text: this.$t('inputs.material'),
				name: 'id',
				value: 'id',
				setValueExpr: val => this.getMaterialById(val)?.name
			},
			{
				text: '',
				name: 'actions',
				value: 'actions',
				noInput: true
			}
		]
		return headers
	},
	headerSameBar() {
		const headers = [
			{
				text: this.$t('inputs.warehouse'),
				name: 'warehouse_id',
				value: 'warehouse_id',
				setValueExpr: val => this.getWarehousesById(val)?.name
			},
			{
				text: this.$t('inputs.material'),
				name: 'id',
				value: 'id',
				setValueExpr: val => this.getMaterialById(val)?.name
			},
			{
				text: this.$t('inputs.barcode'),
				name: 'barcode',
				value: 'barcode'
			},
			{
				text: '',
				name: 'actions',
				value: 'actions'
			}
		]
		return headers
	},
	headersLinkedUnit() {
		return [
			{
				text: 'اسم واحدة التغليف',
				name: 'packagingUnits',
				value: 'packagingUnits'
			},
			{
				text: 'العدد',
				name: 'count',
				value: 'count'
			},
			{
				text: 'الواحدة',
				name: 'unit',
				value: 'unit'
			},
			{
				text: '',
				name: 'actions',
				value: 'actions',
				noInput: true
			}
		]		
	},
	headersRegion() {
		return [
			{
				text: 'اسم المنطقة',
				name: 'name',
				value: 'name'
			},
			{
				text: 'الصف',
				name: 'class',
				value: 'class'
			},
			{
				text: 'العمود',
				name: 'column',
				value: 'column'
			},
			{
				text: 'الملاحظات',
				name: 'notes',
				value: 'notes'
			},
			{
				text: '',
				name: 'actions',
				value: 'actions',
				noInput: true
			}
		]
	},
	materialHeaders() {
		return [
			{
				text: this.$t('MaterialCreateEdit.warehouse'),
				value: 'name',
				name: 'warehouse',
				sortable: false,
				setValueExpr: (value) => this.getWarehousesById(value)?.name,
				inputRules: [this.rules.required],
				width: '32%'
			},
			{
				text: this.$t('MaterialCreateEdit.main-material'),
				value: 'materials',
				name: 'material',
				sortable: false,
				setValueExpr: (value) => this.getMaterialById(value)?.name,
				// inputRules: [this.rules.required],
				width: '32%'
			},
			{ 
				text: this.$t('MaterialCreateEdit.material-no-is-automatic-or-manual'),
				value: 'financial_file_id',
				name: 'number',
				sortable: false,
				setValueExpr: (value, index) =>
					this.materials.find(c => c.id === this.materialItems[index].materials)?.no + value ? value : '',
				inputRules: [this.rules.required],
				width: '32%'
			},
			{
				text: '',
				value: 'actions',
				name: 'actions',
				sortable: false,
				noInput: true,
				width: '4%'
			}
		]
	},

	editStatusHeaders() {
		return [
			{
				text: this.$t('MaterialCreateEdit.warehouse'),
				value: 'warehouse_id',
				setValueExpr: value => this.getWarehousesById(value)?.name,
				name: 'warehouse_id',
				sortable: false
			},
			{
				text: this.$t('inputs.material'),
				value: 'id',
				setValueExpr: value => this.getMaterialById(value)?.name,
				name: 'id',
				sortable: false
			},
			{
				text: this.$t('MaterialCreateEdit.main-material'),
				value: 'parent_id',
				name: 'materials',
				sortable: false,
				width: '32%',
				writable: true
			},
			{ 
				text: this.$t('MaterialCreateEdit.material-no-is-automatic-or-manual'),
				value: 'inner_no',
				name: 'number',
				sortable: false,
				width: '32%',
				writable: true
			}
		]
	},

	allMaterialEditTypes() {
		return [
			{
				name: this.$t('MaterialCreateEdit.non-selected-edit-type'),
				id: null
			},
			...this.materialEditTypes
		]
	},
	useMaterialSerialNumber() {
		return this.getSettingByKey('UseMaterialSerialNumber')?.value;
	},
	warehouse_materials() {
		return this.materials.filter(v => v.warehouse_id === Number(this.$route.params.warehouseId))
	}
},
methods:{
	addMaterialToWarehouses() {
		if (this.$refs.duplicationMaterialTable.validate()) {
			this.materialItems.push({
				id: Date.now(),
				name: this.warehousesInputs.warehouse,
				materials: this.warehousesInputs.material,
				financial_file_id: this.warehousesInputs.number
			})
			this.$refs.duplicationMaterialTable.resetInputs();
		}
	},

	initializeParent(){
		if (this.$route.name != 'update-material' && this.$route.name != 'show-material') // create account
		if(Number(this.$route.params.parentId))
		{
			this.material.parent_id = Number(this.$route.params.parentId)
			this.change()
		}
	},
	save(){
	this.loading = true;
	if(this.material.purchase_price?.amount)
		this.material.purchase_price.currency_id = this.configs.financial_file.default_currency_id 
	else
		this.material.purchase_price = null
	if(this.material.sale_price?.amount)
		this.material.sale_price.currency_id = this.configs.financial_file.default_currency_id 
	else
		this.material.sale_price = null
	if (this.$route.name == 'update-material')
	{	
		store.dispatch("materials/update", { warehouseId: this.$route.params.warehouseId, material: this.material, 
			editStatus: this.materialEditType, 
			destinationMateriallEdit: this.materialEditType === 0 ? 
				this.editStatusItems.map(c => ({
					warehouse_id: c.warehouse_id,
					material_id: c.id,
					new_parent_id: c.parent_id,
					new_inner_no: c.inner_no
				})) :
				[]
		})
		.then(() => 
			{ 
				if(this.addToAllWarehouses === true){
					this.$store.dispatch('materials/updateCopyMaterials',{
						warehouseId: this.$route.params.warehouseId,
						materialId: this.$route.params.id,
						warehousesMaterials: this.materialItems.map(c => ({
							warehouse_id: c.name,
							parent_id: c.materials,
							inner_no: c.financial_file_id,
						}))
					})
				}
				
				this.$store.dispatch('materials/fetchAll').then(() => {
					this.$router.push({ name: "show-material", params: {id: this.$route.params.id}}).catch(()=>{})
					this.reSet();
					this.loading = false;
					this.$emit('reload-materials-tree', () => {})
				});
				
			})
		.catch(() => { this.loading = false});
	}
    else {
        store.dispatch("materials/create", {
			warehouseId: this.$route.params.warehouseId,
			material: this.material,
			materialItems: this.materialItems.map(c => ({
				warehouse_id: c.name,
				parent_id: c.materials,
				inner_no: c.financial_file_id,
			}))
		}).then((id) => 
			{
				this.$store.dispatch('materials/fetchAll').then(() => {
					this.$emit('reload-materials-tree', () => {this.loading = false;this.$router.push({ name: "show-material", params: {id: id}}).catch(()=>{});this.reSet();})
					
				}).finally(() => { this.loading = false});
			})
		.catch(() => { this.loading = false});
        }
      
    },
    cancel(){
		this.$router.push({ name: "show-material"}).catch(()=>{})
	},
	change(){
		this.$nextTick(()=> {
			// store.dispatch("warehouses/GenerateBarcode", { warehouseId: this.$route.params.warehouseId }).then(response =>{
			// 	this.material.barcode = response.data
			// })
			this.$refs.innerNo.setFocus();
			if(this.material.parent_id)
				store.dispatch("materials/GenerateNewInnerNo", { warehouseId: this.$route.params.warehouseId, materialId: this.material.parent_id }).then(response=>{
					this.material.inner_no = response
				})
		});
	},
	suggestMaterialNo(){
		this.$nextTick(()=> {
			if(this.warehousesInputs.material){
				this.$store.dispatch('materials/GenerateNewInnerNo', { warehouseId: this.warehousesInputs.warehouse, materialId: this.warehousesInputs.material }).then(response=>{
					this.warehousesInputs.number = response
				})
			}
		})
	},

	suggestMaterialEditNo(index){
		this.$nextTick(()=> {
			if(this.editStatusItems[index].parent_id){
				this.editTableLoading = true
				this.$store.dispatch('materials/GenerateNewInnerNo', {
					warehouseId: this.editStatusItems[index].warehouse_id,
					materialId: this.editStatusItems[index].parent_id
				}).then(data => {
					this.editStatusItems[index].inner_no = data
				}).finally(() => {
					this.editTableLoading = false
				})
			}
		})
	},

	assignMoneyAmount(amount, currency_id){
      if(amount)
        return {amount, currency_id}
      return null
	},
	reSet(){
		this.deleteDialog = false
		this.material = {...this.default_material}
		this.$refs.form.resetValidation()
	},
	confirmDelete(){
		this.loading = true
		store.dispatch("materials/delete", { warehouseId: this.$route.params.warehouseId, materialId: this.$route.params.id })
			.then(() => 
				{ 
					// this.$router.go(-1)
					this.$store.dispatch("materials/fetchAll").then(()=> {

						this.$emit('reload-materials-tree', () => {this.loading = false;this.$router.push({ name: "materials-tree"}).catch(()=>{});this.reSet()})
					})
				})
			.catch(() => { 
				this.loading = false 
			});
	},

	getMaterialLinked() {
		if (this.$route.params.id) {
			this.$store.dispatch('warehouses/fetchMaterialLinkedWithMaterial', {
				materialId: this.$route.params.id
			}).then((data) => {
				this.itemLinkedWithMaterials = data.data
				this.editStatusItems = data.data.map(c => ({
					warehouse_id: c.warehouse_id,
					id: c.id,
					parent_id: c.parent_id,
					inner_no: c.inner_no,
				}))
			})
		}
	},

	getMaterialBySameBarcode() {
		if (!this.material.barcode) return
		return this.$store.dispatch('warehouses/fetchMaterialSameBarcode', { 
			materialId: this.$route.params.id, 
			barcode: this.material.barcode
		}).then((data) => {
			this.materialSameBarcode = data.data
		})
	},

	link(id) {
		this.loading = true
		this.$store.dispatch('warehouses/linkedMaterial', { 
			materialId: this.$route.params.id, 
			linkedMaterialId: id ? id : this.tableInputs.id
		}).then(() => {
			this.getMaterialLinked()
			if(id) {
				this.getMaterialBySameBarcode()
			}
		}).finally(() => {
			this.loading = false
			this.$refs.table.resetInputs()
		})
	},

	// deleteLinkItem () {
	// 	this.loading = true
	// 	this.$store.dispatch('warehouses/deleteLinkedItem', { 
	// 		materialId: this.$route.params.id, 
	// 		linkedMaterialId: this.itemId 
	// 	}).then(() => {
	// 		this.getMaterialBySameBarcode().finally(() => {
	// 			this.loading = false
	// 			this.itemId = null
	// 			this.unbindDialog = false
	// 		})
	// 		this.getMaterialLinked()
	// 	}).catch(() => {
	// 		this.loading = true
	// 	})
	deleteLinkItem () {
		this.loading = true
		this.$store.dispatch('warehouses/deleteLinkedItem', { 
			materialId: this.$route.params.id, 
			linkedMaterialId: this.itemId 
		}).then(() => {
			this.getMaterialBySameBarcode()
			this.getMaterialLinked()
		}).finally(() => {
			this.loading = false
			this.itemId = null
			this.unbindDialog = false
		})
	},
	addUnitsLinked() {
		this.entriesUnitsLinked.push({
			...this.tableInputsUnitLinked
		})
		this.$refs.unitLinkedTable.resetInputs()
	},
	editUnitsLinked() {
		this.entriesUnitsLinked[this.rowEditIndexUnit].packagingUnits = this.tableInputsUnitLinked.packagingUnits
		this.entriesUnitsLinked[this.rowEditIndexUnit].unit = this.tableInputsUnitLinked.unit
		this.entriesUnitsLinked[this.rowEditIndexUnit].count = this.tableInputsUnitLinked.count

		this.resetEditUnit = true
		this.$refs.unitLinkedTable.resetEdit()
		this.isEditUnit = false
		this.resetEditRegion 
		this.$refs.unitLinkedTable.resetInputsFocus()
		this.$refs.unitLinkedTable.resetInputs()
	},

	setRowIndexUnit(rowData) {
		this.rowEditIndexUnit = rowData.index;
		this.unitId = rowData.id;
		this.isEditUnit = true
		this.$nextTick(() => {
			this.$refs.unitLinkedTable.resetInputsFocus()
		})
	},

	deleteUnit(index) {
		this.entriesUnitsLinked.splice(index, 1)
	},

	getClassAndColumn() {
		const region = this.regions.find(c => c.id === this.tableInputRegion.name)
		this.tableInputRegion.class = region.class
		this.tableInputRegion.column = region.column
	},
	addRegion() {
		this.itemsRegion.push({
			...this.tableInputRegion
		})
	},
	// editRegion() {
	// 	this.itemsRegion
	// },
		
	editRegion () {
		this.itemsRegion[this.rowEditIndexRegion].name = this.tableInputRegion.name
		this.itemsRegion[this.rowEditIndexRegion].class = this.tableInputRegion.class
		this.itemsRegion[this.rowEditIndexRegion].column = this.tableInputRegion.column
		this.itemsRegion[this.rowEditIndexRegion].notes = this.tableInputRegion.notes

		this.resetEditRegion = true
		this.$refs.regionTable.resetEdit()
		this.isEditRegion = false
		this.resetEditRegion 
		this.$refs.regionTable.resetInputsFocus()
		this.$refs.regionTable.resetInputs()
	},
	setRowIndexRegion(rowData) {
		this.rowEditIndexRegion = rowData.index;
		this.regionId = rowData.id;
		this.isEditRegion = true
		this.$nextTick(() => {
			this.$refs.regionTable.resetInputsFocus()
		})
	},

	deleteRegion({ index }) {
		this.itemsRegion.splice(index, 1)
	},

	// this solution is for the tree materials
	// async fetchMaterial(warehouseId, materialId) {
	// 	try {
	// 	// Fetch material data
	// 	const materialResponse = await store.dispatch("materials/fetch", {
	// 		warehouseId: Number(warehouseId),
	// 		materialId: Number(materialId),
	// 	});
	// 	this.material = materialResponse;

	// 	// Fetch materials with the same barcode (if barcode exists)
	// 	if (this.material.barcode) {
	// 		const barcodeResponse = await store.dispatch('warehouses/fetchMaterialSameBarcode', {
	// 		materialId: materialId,
	// 		barcode: this.material.barcode,
	// 		});
	// 		this.materialSameBarcode = barcodeResponse.data;
	// 	}
	// 	} catch (error) {
	// 	console.error('Error fetching material:', error);
	// 	}
	// },
	
},
watch: {
	$route(val){
		this.copyToOtherWarehouses = false;
		if(val.name === 'show-material') {
			this.readonly = true;
		} else {
			this.readonly = false;
		}
		if(val.name == "update-material") {
			this.copyToOtherWarehouses = true;
		} 
		this.addToAllWarehouses = false;
		this.materialEditType = null;
		this.materialItems = [];
		this.editStatusItems = [];
		this.warehousesInputs = {};

		if(val.name == "add-material")
		{
			this.reSet() 
			this.initializeParent() 
		}

		if(val.name == "create-material")
			this.reSet() 
	}
},

// old work (before i added anything... this code was here at the start)
// async beforeRouteEnter(to, from, next) {
//     next(vm => {
// 		if(to.params.id) {	
// 		store.dispatch("materials/fetch", { 
// 			warehouseId: Number(to.params.warehouseId), 
// 			materialId: Number(to.params.id) }).then((response) => { 
// 				vm.material = {...response } 
// 				if(vm.material.barcode) {
// 					store.dispatch('warehouses/fetchMaterialSameBarcode', { 
// 						materialId: vm.$route.params.id, 
// 						barcode: vm.material.barcode
// 					}).then((data) => {
// 						vm.materialSameBarcode = data.data
// 					})
// 				}
// 			})	
// 		}
// 	})
// }


// the corrent code of the tree
async beforeRouteEnter(to, from, next) {
  next(async (vm) => {
    try {
      if (to.params.id) {
        // Fetch material data
        const response = await store.dispatch("materials/fetch", {
          warehouseId: Number(to.params.warehouseId),
          materialId: Number(to.params.id),
        });
        vm.material = { ...response }; // Update reactive property
		// Fetch materials with the same barcode (if barcode exists)
		if (vm.material.barcode) {
				const data = await store.dispatch('warehouses/fetchMaterialSameBarcode', {
					materialId: vm.$route.params.id,
					barcode: vm.material.barcode,
				});
				vm.materialSameBarcode = data.data; // Update reactive property
				}
			}
			} catch (error) {
			console.error('Error in beforeRouteEnter:', error); // Debugging: Log errors
			// console.log('we\'ve an  error in the first part')
			}
		});
		},
	async beforeRouteUpdate(to, from, next) {
	this.addToAllWarehouses = false;
	this.materialItems = [];
	this.warehousesInputs = {};
	try {
		if (to.params.id) {
		// Fetch material data when route parameters change
		this.reSet();
		const response = await store.dispatch("materials/fetch", {
			warehouseId: Number(to.params.warehouseId),
			materialId: Number(to.params.id),
		});
		this.material = { ...response }; // Update reactive property

		// Fetch materials with the same barcode (if barcode exists)
		if (this.material.barcode) {
			const data = await store.dispatch('warehouses/fetchMaterialSameBarcode', {
			materialId: to.params.id,
			barcode: this.material.barcode,
			});
			this.materialSameBarcode = data.data; // Update reactive property
		}
		}
	} catch (error) {
		console.error('Error in beforeRouteUpdate:', error); // Debugging: Log errors
	}
	next(); // Proceed with the navigation
	},





// the new solution (to change between the warehouses) + the commment in the methods
// beforeRouteEnter(to, from, next) {
//   next(async (vm) => {
//     if (to.params.id) {
//       await vm.fetchMaterial(to.params.warehouseId, to.params.id); // Fetch data on route enter
//     }
//   });
// },
// async beforeRouteUpdate(to, from, next) {
//   if (to.params.id) {
//     await this.fetchMaterial(to.params.warehouseId, to.params.id); // Fetch data on route update
//   }
//   next();
// },
// async created() {
//   // Fetch data when the component is created (first load)
//   if (this.$route.params.id) {
//     await this.fetchMaterial(this.$route.params.warehouseId, this.$route.params.id);
//   }
// },



};
</script>
<style>
.v-treeview-node__label{
  white-space: normal;
}
</style>
